<div class="col mb-3">
    <div class="header">{{ header }} <span *ngIf="keyRequired" >*</span></div>

  <div class="btn-group w-100" ngbDropdown (openChange)="onDropdownOpenChange($event)" style="position: relative;">
        <div class="input-group">
        <input
            ngbDropdownToggle
            type="text"
            class="form-control w-100"
            [ngClass]="{'error-border': showRequiredError, 'has-left-icon': hasIcon}"
            [(ngModel)]="searchTerm"
            [placeholder]="placeholder"
            (input)="onInputChange($event)"
            (click)="($event.stopPropagation())"
        />
        <i class="fa fa-angle-down"></i>
        <span class="select-icon-left" *ngIf="hasIcon">
          <i [ngClass]="resolvedIconClass"></i>
        </span>
        </div>

        <ul ngbDropdownMenu class="dropdown-menu w-100" style="border-radius: 8px;">
            <div class="scroll" style="overflow-y: auto; max-height: 250px; padding: 0; margin: 0; border-radius: 8px; ">

        <!-- First Item: Full-width Button -->
                <li ngbDropdownItem style="padding: 0; margin: 0;background-color: #FFF1F2; ">
                    <button
                    class="btn w-100"
                    style="border-radius: 0; padding: 10px; text-align: start; color: #DB1E49;font-weight: 600;text-decoration: underline;"
                    type="button" data-bs-toggle="modal" 
                    [attr.data-bs-target]="'#' + addmodalId"
                    (click)="log()">
                    +Add New {{header}}
                    </button>
                </li>

        <!-- Remaining Items -->
                <li
                    *ngFor="let item of filteredItems; let i = index"
                    ngbDropdownItem
                    style="display: flex; align-items: center; padding: 5px 10px; gap: 8px; border: none; cursor: pointer;"
                    class="dropdownItems"
                    (click)="selectOption(item)"
                    [style.marginTop.px]="i === 0 ? 0 : 0" 
                >
                    <!-- Small Button -->
                    <button
                    *ngIf="itemExists(item) && ShowEdit"
                    type="button"
                    class="btn btn-outline btn-sm addbtn"
                    (click)="openEditModal(item.name,item.id); $event.stopPropagation()"
                    data-bs-toggle="modal"
                    data-bs-target="#editModal"
                    >
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.6556 3.43923L8.56079 1.34485C8.49114 1.27519 8.40845 1.21993 8.31745 1.18223C8.22644 1.14453 8.1289 1.12512 8.0304 1.12512C7.93189 1.12512 7.83435 1.14453 7.74334 1.21993 7.65234 1.27519 7.56965 1.34485 7.50001 1.34485L1.71985 7.12501C1.6499 7.1944 1.59444 7.277 1.5567 7.36802C1.51896 7.45903 1.49969 7.55664 1.5 7.65517V9.75001C1.5 9.94892 1.57902 10.1397 1.71967 10.2803C1.86033 10.421 2.05109 10.5 2.25 10.5H10.125C10.2245 10.5 10.3198 10.4605 10.3902 10.3902C10.4605 10.3198 10.5 10.2245 10.5 10.125C10.5 10.0256 10.4605 9.93017 10.3902 9.85984C10.3198 9.78952 10.2245 9.75001 10.125 9.75001H5.40563L10.6556 4.50001C10.7253 4.43036 10.7806 4.34768 10.8183 4.25667C10.856 4.16566 10.8754 4.06812 10.8754 3.96962C10.8754 3.87111 10.856 3.77357 10.8183 3.68257C10.7806 3.59156 10.7253 3.50887 10.6556 3.43923ZM4.34485 9.75001H2.25V7.65517L6.37501 3.53016L8.46985 5.62501L4.34485 9.75001ZM9.00001 5.09485L6.90563 3.00001L8.03063 1.87501L10.125 3.96985L9.00001 5.09485Z" fill="#DB1E49"/>
                    </svg>
                    </button>


                    <!-- Item Name -->
                    <span>{{ item.name }}</span>

                </li>

            </div>
        </ul>
    </div>
    <div *ngIf="showRequiredError" class="text-danger">
    This field is required
    </div>
</div>



<!-- Modal -->

<app-form-modal [Singlefields]=true modalId="{{addmodalId}}" Modaltitle="Create" [header]="'Add New '+ header" leftButtonTitle="Cancel" rightButtonTitle="Add" (value)="Additem($event)" ></app-form-modal>

<app-form-modal [Singlefields]=true [inputValue]="selectedItem" modalId="editModal" Modaltitle="Edit" [header]="'Edit ' +header" leftButtonTitle="Cancel" rightButtonTitle="Edit" (value)="editItem($event)" ></app-form-modal>